/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */
/* eslint-disable max-statements */

/**
 * @param {string} dataUrl
 * @returns {Promise<HTMLCanvasElement>}
 */
export async function canvasFromDataUrl(dataUrl) {
  const img = new Image();
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = dataUrl;
  });

  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to get canvas context');
  }
  ctx.drawImage(img, 0, 0);
  return canvas;
}

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Record<'threshold', number>} options
 * @returns {{blackPixels: number, whitePixels: number}}
 */
export function analyzeColors(ctx, { threshold = 10 }) {
  const { height, width } = ctx.canvas;
  const { data } = ctx.getImageData(0, 0, width, height);
  let blackPixels = 0;
  let whitePixels = 0;
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    if (r <= threshold && g <= threshold && b <= threshold) {
      blackPixels += 1;
    } else if (
      r >= 255 - threshold &&
      g >= 255 - threshold &&
      b >= 255 - threshold
    ) {
      whitePixels += 1;
    }
  }
  return {
    blackPixels,
    whitePixels
  };
}

/**
 * @param {CanvasImageSource} canvasImageSource
 * @param {Record<'width' | 'height', number>} options
 * @returns {HTMLCanvasElement}
 */
export function scaleImageToSize(canvasImageSource, { width, height }) {
  const downscaledCanvas = document.createElement('canvas');
  downscaledCanvas.width = width;
  downscaledCanvas.height = height;
  const ctx = downscaledCanvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to get canvas context');
  }
  ctx.drawImage(canvasImageSource, 0, 0, width, height);
  return downscaledCanvas;
}
